import { PageDoesntExist } from "@/pageDoesntExist";
import { TreasureHunt } from "branchAndBrandSpecific/features/treasure-hunt/TreasureHunt";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { siteRoutes } from "../siteRoutesList";

export const treasurehuntRoutes = [
  {
    element: brand.hasFeature.treasure_hunt ? TreasureHunt : PageDoesntExist,
    path: `${siteRoutes["treasureHunt"]}:thid`,
  },
  {
    element: brand.hasFeature.treasure_hunt ? TreasureHunt : PageDoesntExist,
    path: siteRoutes["treasureHunt"],
  },
];
